export default __webpack_public_path__ + "static/media/B0004.e7a97f97.png";